import {Grid2} from '@mui/material';
import {getLoginToken} from 'infra/http/utils';
import {HomeEnum, SignInEnum} from 'presentation/constants';
import {useFacialBiometricFeatureFlag} from 'presentation/pages/private/hooks/useFacialBiometricFeatureFlag';
import React, {useEffect} from 'react';
import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {
	useCurrentStepStore,
	useDivergentAttemptsStore,
	useFacePhotoStore,
	useGuardianStore,
} from './store';
import {BIOMETRIC_STEPS} from './constants';
import {useAccountInformation} from 'presentation/pages/private';

export function FacialBiometricsWrapper() {
	const loginToken = getLoginToken();
	const {isEnabled: isFacialBiometricEnabled} = useFacialBiometricFeatureFlag();
	const {odontoOnly} = useAccountInformation();

	const location = useLocation();

	const {currentStep, reset, setStep} = useCurrentStepStore();
	const resetAttempts = useDivergentAttemptsStore(state => state.reset);
	const resetFacePhotos = useFacePhotoStore(state => state.reset);
	const resetGuardian = useGuardianStore(state => state.reset);

	const stepIndex = BIOMETRIC_STEPS.findIndex(step => step === location.pathname);

	useEffect(() => {
		return () => {
			reset();
			resetAttempts();
			resetFacePhotos();
			resetGuardian();
		};
	}, []);

	useEffect(() => {
		if (stepIndex === -1) return;

		if (stepIndex > currentStep) {
			setStep(currentStep);
			return;
		}

		if (stepIndex < currentStep) {
			setStep(stepIndex);
		}
	}, [location.pathname]);

	if (stepIndex > currentStep) {
		return <Navigate to={BIOMETRIC_STEPS[currentStep]} replace />;
	}

	if (!loginToken) {
		return <Navigate to={SignInEnum.SIGN_IN} state={{goToSignInState: true}} replace />;
	}

	if (!isFacialBiometricEnabled || odontoOnly) {
		return <Navigate to={HomeEnum.HOME_PAGE} replace />;
	}

	return (
		<Grid2
			size={{xs: 12, lg: 8.5, md: 7.6}}
			height="100vh"
			gap={4}
			display="flex"
			flexDirection="column">
			<Outlet />
		</Grid2>
	);
}
